/**
 * features/shell/Sidebar.tsx — เมนูข้าง
 */

import { NavLink } from 'react-router-dom';
import {
  FileText,
  LayoutDashboard,
  LineChart,
  Package,
  Receipt,
  Settings,
  Truck,
  Users,
  Wallet,
} from 'lucide-react';
import { cn } from '~/lib/cn';
import { useAuth } from '~/features/auth/auth-context';

interface NavItem {
  to: string;
  label: string;
  icon: typeof LayoutDashboard;
  adminOnly?: boolean;
}

const NAV_ITEMS: NavItem[] = [
  { to: '/', label: 'แดชบอร์ด', icon: LayoutDashboard },
  { to: '/quotations', label: 'ใบเสนอราคา', icon: FileText },
  { to: '/tax-invoices', label: 'ใบเสร็จ/ใบกำกับภาษี', icon: Receipt },
  { to: '/expenses', label: 'ค่าใช้จ่าย', icon: Wallet },
  { to: '/reports/vat', label: 'รายงานภาษี', icon: LineChart },
  { to: '/customers', label: 'ลูกค้า', icon: Users },
  { to: '/suppliers', label: 'ผู้ขาย/คู่ค้า', icon: Truck },
  { to: '/products', label: 'สินค้า/บริการ', icon: Package },
  { to: '/settings', label: 'ตั้งค่า', icon: Settings, adminOnly: true },
];

export function Sidebar({ onNavigate }: { onNavigate?: () => void }) {
  const { isAdmin } = useAuth();

  return (
    <nav className="flex h-full flex-col gap-0.5 p-2.5" aria-label="เมนูหลัก">
      {NAV_ITEMS.filter((item) => !item.adminOnly || isAdmin).map((item) => {
        const Icon = item.icon;
        return (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            onClick={onNavigate}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-2.5 rounded-md px-3 py-2 text-sm font-medium transition-colors',
                isActive
                  ? 'bg-accent-soft text-accent-fg'
                  : 'text-fg-muted hover:bg-surface-hover hover:text-fg',
              )
            }
          >
            <Icon size={17} aria-hidden />
            {item.label}
          </NavLink>
        );
      })}
    </nav>
  );
}
